/* FRANK NOVA — zaglavlje: ponasanje 1:1 po JF jf-header-v2.js (smoots sm-mega-menu-live / sm-mobile-menu-live / sm-header-live). Posjeduje agent MENI. Bez jQueryja.
   Mega meni: mouseenter okidaca = odmah otvori; mouseleave okidaca/panela = zatvori nakon 160 ms; klik = otvori/zatvori (panel otvoren hoverom klik ne zatvara);
   klik izvan zaglavlja, Esc (fokus natrag na okidac) i fokus izvan zatvaraju. Tabovi: hover i klik. Dok je meni otvoren stranica se ne pomice (kotacic/dodir).
   Mobilni: panel klizi zdesna (.3 s), zakljucan skrol, Esc zatvara. Traka se skriva pri skrolu dolje (>80 px, prag 8 px), vraca pri skrolu gore.
   Dodano za Frank: broj u kosarici (dogadjaj jfn:cart:updated + /cart.js), Reviews.io ocjena u traci, odabir zemlje (details). */
(function () {
	'use strict';
	var d = document, html = d.documentElement, root = d.querySelector('[data-jfh-root]');
	if (!root) { return; }
	/* 22.10.2026. SEO: mega meni, mobilni izbornik i kosarica su u sekciji jfn-header-late na KRAJU body-ja ([data-jfh-late]); trazimo ih u oba korijena, a CSS varijable postavljamo na oba. */
	var late = d.querySelector('[data-jfh-late]');
	function qa(s) { var a = [].slice.call(root.querySelectorAll(s)); return late ? a.concat([].slice.call(late.querySelectorAll(s))) : a; }
	function q1(s) { return root.querySelector(s) || (late ? late.querySelector(s) : null); }
	function setVar(k, v) { root.style.setProperty(k, v); if (late) { late.style.setProperty(k, v); } }
	var bar = q1('.jfh-bar'), mega = q1('[data-jfh-mega]');
	var dds = {}, tts = {};
	[].forEach.call(qa('[data-jfh-dd]'), function (el) { dds[el.getAttribute('data-jfh-dd')] = el; });
	[].forEach.call(qa('[data-jfh-trigger]'), function (el) { tts[el.getAttribute('data-jfh-trigger')] = el; });
	var openName = null, hoverTimer = 0, openedBy = '';

	function setTop() { if (bar) { setVar('--jfh-nav-top', Math.max(0, Math.floor(bar.getBoundingClientRect().bottom)) + 'px'); } }
	/* pracenje donjeg ruba trake kroz tranziciju (translate .25 s): rAF petlja dok traje + nakon transitionend */
	var trackRaf = 0;
	function trackTop(ms) {
		var t0 = performance.now();
		cancelAnimationFrame(trackRaf);
		(function step(t) { if (!openName) { return; } setTop(); if (t - t0 < ms) { trackRaf = requestAnimationFrame(step); } })(t0);
	}
	if (bar) { bar.addEventListener('transitionend', function () { if (openName) { setTop(); } }); }
	function lockD(on) { html.classList.toggle('jfh-lock-d', !!on); }
	function setExp(name, on) { var t = tts[name]; if (!t) { return; } t.classList.toggle('is-open', on); var a = t.querySelector('[aria-expanded]'); if (a) { a.setAttribute('aria-expanded', on ? 'true' : 'false'); } }
	function open(name) {
		if (!dds[name]) { return; }
		setTop();
		if (openName && openName !== name) { dds[openName].classList.remove('is-active'); setExp(openName, false); }
		dds[name].classList.add('is-active'); setExp(name, true);
		if (mega) { mega.classList.add('is-open'); }
		root.classList.remove('is-scroll-hidden');
		root.classList.add('is-menu-open');
		lockD(true);
		openName = name;
		trackTop(400);
	}
	function close() {
		if (!openName) { return; }
		dds[openName].classList.remove('is-active'); setExp(openName, false);
		if (mega) { mega.classList.remove('is-open'); }
		lockD(false);
		root.classList.remove('is-menu-open');
		openName = null;
	}
	Object.keys(tts).forEach(function (name) {
		var t = tts[name];
		t.addEventListener('mouseenter', function () { clearTimeout(hoverTimer); if (openName !== name) { openedBy = 'hover'; } open(name); });
		t.addEventListener('mouseleave', function () { hoverTimer = setTimeout(close, 160); });
		/* strelica: klik/Enter/Space = toggle (panel otvoren hoverom klik NE zatvara); tekst = pravi link (<a href>); na dodir prvi tap na tekst otvara panel, drugi vodi na stranicu */
		var arr = t.querySelector('.jfh-lk-arr'), lnk = t.querySelector('.jfh-lk-a');
		if (arr) { arr.addEventListener('click', function (e) { e.preventDefault(); clearTimeout(hoverTimer); if (openName === name && openedBy === 'click') { close(); } else { open(name); openedBy = 'click'; } }); }
		if (lnk) { lnk.addEventListener('click', function (e) { if (window.matchMedia && window.matchMedia('(hover: none)').matches && openName !== name) { e.preventDefault(); clearTimeout(hoverTimer); open(name); openedBy = 'click'; } }); }
	});
	Object.keys(dds).forEach(function (name) {
		dds[name].addEventListener('mouseenter', function () { clearTimeout(hoverTimer); });
		dds[name].addEventListener('mouseleave', function () { hoverTimer = setTimeout(close, 160); });
	});
	d.addEventListener('click', function (e) { if (openName && !bar.contains(e.target) && !(mega && mega.contains(e.target) && !e.target.classList.contains('jfh-backdrop'))) { close(); } });
	d.addEventListener('keydown', function (e) { if (e.key === 'Escape' && openName) { var n = openName, fa = tts[n].querySelector('.jfh-lk-arr'); close(); if (fa) { fa.focus(); } } });
	d.addEventListener('focusout', function () { if (!openName) { return; } requestAnimationFrame(function () { var a = d.activeElement; if (!a || !(bar.contains(a) || (mega && mega.contains(a)))) { close(); } }); });
	window.addEventListener('resize', function () { if (openName) { setTop(); } });
	/* dok je meni otvoren: kotacic/dodir na pozadini i traci ne pomice stranicu (Safari rubber band) */
	var stop = function (e) {
		if (!openName) { return; }
		var dd = e.target.closest && e.target.closest('.jfh-dd');
		if (!dd) { e.preventDefault(); return; }
		/* unutar panela: dopusti samo ako panel sam moze skrolati u tom smjeru (inace bi se pomaknula stranica) */
		if (e.type === 'wheel') {
			var dy = e.deltaY, el = e.target, ok = false;
			while (el && el !== dd.parentNode) {
				if (el.nodeType === 1 && el.scrollHeight > el.clientHeight + 1 && /(auto|scroll)/.test(getComputedStyle(el).overflowY)) {
					if ((dy < 0 && el.scrollTop > 0) || (dy > 0 && el.scrollTop + el.clientHeight < el.scrollHeight - 1)) { ok = true; break; }
				}
				if (el === dd) { break; }
				el = el.parentNode;
			}
			if (!ok) { e.preventDefault(); }
		}
	};
	window.addEventListener('wheel', stop, { passive: false });
	window.addEventListener('touchmove', stop, { passive: false });
	d.addEventListener('keydown', function (e) { if (openName && [' ', 'PageDown', 'PageUp', 'ArrowDown', 'ArrowUp', 'Home', 'End'].indexOf(e.key) > -1 && !e.target.closest('input, textarea, select, .jfh-dd')) { e.preventDefault(); } });

	/* tabovi lijevo (hover + klik), po panelu */
	[].forEach.call(qa('.jfh-dd'), function (dd) {
		var tabs = [].slice.call(dd.querySelectorAll('[data-jfh-tab]')), panels = [].slice.call(dd.querySelectorAll('[data-jfh-panel]'));
		tabs.forEach(function (tab) {
			var act = function () { var k = tab.getAttribute('data-jfh-tab'); tabs.forEach(function (t) { t.classList.toggle('is-active', t === tab); }); panels.forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-jfh-panel') === k); }); };
			tab.addEventListener('mouseenter', act); tab.addEventListener('click', act); tab.addEventListener('focus', act);
		});
	});

	/* cipovi kategorija (hover/fokus; klik ide na stvarnu poveznicu), po panelu */
	[].forEach.call(qa('.jfh-dd'), function (dd) {
		var chips = [].slice.call(dd.querySelectorAll('[data-jfh-chip]')), cats = [].slice.call(dd.querySelectorAll('[data-jfh-cat]'));
		chips.forEach(function (c) {
			var act = function () { var k = c.getAttribute('data-jfh-chip'); chips.forEach(function (x) { x.classList.toggle('is-active', x === c); }); cats.forEach(function (x) { x.classList.toggle('is-active', x.getAttribute('data-jfh-cat') === k); }); };
			c.addEventListener('mouseenter', act); c.addEventListener('focus', act);
		});
	});

	/* pretraga: ikona otvara formu (bez JS-a ikona je link na /search); Esc / klik izvan zatvara */
	var sTr = q1('[data-jfh-search-trigger]'), sFm = q1('#jfh-search');
	if (sTr && sFm) {
		var sSet = function (on) { sFm.hidden = !on; sTr.setAttribute('aria-expanded', on ? 'true' : 'false'); if (on) { var i = sFm.querySelector('input[type=search]'); if (i) { i.focus(); } } };
		sTr.addEventListener('click', function (e) { e.preventDefault(); sSet(sFm.hidden); });
		d.addEventListener('click', function (e) { if (!sFm.hidden && !sFm.contains(e.target) && !sTr.contains(e.target)) { sSet(false); } });
		d.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !sFm.hidden) { sSet(false); sTr.focus(); } });
	}

	/* pauza poruka */
	var pause = q1('[data-jfh-pause]');
	if (pause) { pause.addEventListener('click', function () { var p = root.classList.toggle('is-paused'); pause.setAttribute('aria-pressed', p ? 'true' : 'false'); }); }
	/* odabir zemlje (traka i zaglavlje): jedan otvoren odjednom; zatvori izvan klika / Esc */
	var locs = [].slice.call(qa('[data-jfh-loc]'));
	locs.forEach(function (l) { l.addEventListener('toggle', function () { if (l.open) { locs.forEach(function (o) { if (o !== l) { o.open = false; } }); } }); });
	d.addEventListener('click', function (e) { locs.forEach(function (l) { if (l.open && !l.contains(e.target)) { l.open = false; } }); });
	d.addEventListener('keydown', function (e) { if (e.key === 'Escape') { locs.forEach(function (l) { if (l.open) { l.open = false; var sm = l.querySelector('summary'); if (sm) { sm.focus(); } } }); } });

	/* mobilni izbornik */
	var mm = q1('[data-jfh-mm]');
	function mmIsOpen() { return mm && mm.classList.contains('is-open'); }
	function mmSet(on) {
		if (!mm) { return; }
		if (!on) { spReset(); }
		mm.classList.toggle('is-open', on); html.classList.toggle('jfh-lock', on);
		[].forEach.call(qa('[data-jfh-mm-trigger]'), function (t) { t.setAttribute('aria-expanded', on ? 'true' : 'false'); });
		if (on) { var c = mm.querySelector('[data-jfh-mm-close]'); if (c) { c.focus({ preventScroll: true }); } root.classList.remove('is-scroll-hidden'); }
	}
	d.addEventListener('click', function (e) {
		if (e.target.closest('[data-jfh-mm-trigger]')) { e.preventDefault(); mmSet(!mmIsOpen()); }
		else if (e.target.closest('[data-jfh-mm-close]')) { e.preventDefault(); mmSet(false); }
	});
	d.addEventListener('keydown', function (e) { if (e.key === 'Escape' && mmIsOpen()) { mmSet(false); } });
	/* podstranice (plocice kategorija, Shop, Wissen): klik na okidac [data-jfh-sub] otvara podstranicu (slide 200 ms) preko prethodne; natrag / Esc / swipe udesno zatvara samo gornju; fokus na naslov pa natrag na okidac */
	var spStack = [];
	function spRender() {
		var top = spStack.length ? spStack[spStack.length - 1].sp : null;
		[].forEach.call(mm.querySelectorAll('.jfh-mm-head, .jfh-mm-body, .jfh-mm-foot'), function (el) { el.inert = !!top; });
		[].forEach.call(mm.querySelectorAll('[data-jfh-sp]'), function (sp) { sp.inert = sp !== top; });
	}
	function spPush(sp, trigger) {
		spStack.push({ sp: sp, trigger: trigger });
		sp.classList.add('is-open');
		trigger.setAttribute('aria-expanded', 'true');
		spRender();
		var t = sp.querySelector('.jfh-mm-sp-t'); if (t) { t.focus({ preventScroll: true }); }
	}
	function spPop(refocus) {
		var e = spStack.pop(); if (!e) { return; }
		e.sp.classList.remove('is-open');
		e.trigger.setAttribute('aria-expanded', 'false');
		spRender();
		if (refocus !== false) { e.trigger.focus({ preventScroll: true }); }
	}
	function spReset() { while (spStack.length) { spPop(false); } }
	if (mm) {
		mm.addEventListener('click', function (e) {
			var tr = e.target.closest('[data-jfh-sub]');
			if (tr) { var sp = mm.querySelector('#' + tr.getAttribute('aria-controls')); if (sp) { e.preventDefault(); spPush(sp, tr); } return; }
			if (e.target.closest('[data-jfh-sp-back]') && spStack.length) { e.preventDefault(); spPop(); }
		});
		d.addEventListener('keydown', function (e) { if (e.key === 'Escape' && spStack.length) { e.stopImmediatePropagation(); spPop(); } }, true);
		/* swipe udesno = natrag: pasivni touch, vodoravno tek kad je pomak >10 px i jasno vodoravan (vertikalni skrol ostaje netaknut); prag 30 % sirine ili brz potez */
		var sw = null;
		mm.addEventListener('touchstart', function (e) {
			var top = spStack.length ? spStack[spStack.length - 1].sp : null;
			if (!top || e.touches.length !== 1 || !top.contains(e.target)) { sw = null; return; }
			sw = { sp: top, x: e.touches[0].clientX, y: e.touches[0].clientY, t: e.timeStamp, dx: 0, axis: '' };
		}, { passive: true });
		mm.addEventListener('touchmove', function (e) {
			if (!sw) { return; }
			var dx = e.touches[0].clientX - sw.x, dy = e.touches[0].clientY - sw.y;
			if (!sw.axis) {
				if (Math.abs(dx) < 10 && Math.abs(dy) < 10) { return; }
				sw.axis = dx > 0 && Math.abs(dx) > Math.abs(dy) * 1.5 ? 'x' : 'y';
			}
			if (sw.axis !== 'x') { return; }
			sw.dx = Math.max(0, dx);
			sw.sp.style.transition = 'none';
			sw.sp.style.transform = 'translateX(' + sw.dx + 'px)';
		}, { passive: true });
		var swEnd = function (e) {
			var s = sw; sw = null;
			if (!s || s.axis !== 'x') { return; }
			s.sp.style.transition = ''; s.sp.style.transform = '';
			if (e.type === 'touchend' && (s.dx > s.sp.offsetWidth * 0.3 || (s.dx > 40 && s.dx / Math.max(1, e.timeStamp - s.t) > 0.5))) { spPop(); }
		};
		mm.addEventListener('touchend', swEnd, { passive: true });
		mm.addEventListener('touchcancel', swEnd, { passive: true });
	}
	d.addEventListener('toggle', function (e) { var g = e.target; if (!g.classList || !g.classList.contains('jfh-mm-group') || !g.open) { return; } var body = g.closest('.jfh-mm-body'); if (body) { requestAnimationFrame(function () { body.scrollTo({ top: g.getBoundingClientRect().top - body.getBoundingClientRect().top + body.scrollTop - 8, behavior: 'smooth' }); }); } }, true);

	/* skrol (rAF): y < 10 = puno zaglavlje; y > 80 = plutajuci pillovi (bez bijele pozadine); izmedju bez promjene (histereza).
	   Dolje > 8 px = sakrij, gore > 8 px = pokazi. Negativni scrollY (Safari rubber band) = 0. Bez citanja layouta u petlji. */
	var strip = q1('.jfh-strip'), stripH = 0;
	function measure() { stripH = strip ? strip.offsetHeight : 0; }
	function placeBar() { setVar('--jfh-bar-y', stripH + 'px'); } // 9.10.2026. (David): cijeli header stoji gore (traka je sticky), meni je uvijek ispod nje
	var lastY = Math.max(0, window.scrollY), ticking = false;
	function onScroll() {
		ticking = false;
		if (html.classList.contains('js-drawer-open')) { lastY = Math.max(0, window.scrollY); return; } /* bocna kosarica (Impulse drawer) zakljucava skrol: stanje zaglavlja se ne mijenja */
		var y = Math.max(0, window.scrollY);
		placeBar(y);
		if (y < 10) { root.classList.remove('is-floating', 'is-scroll-hidden'); lastY = y; }
		else {
			if (y > 80) { root.classList.add('is-floating'); }
			if (mmIsOpen() || openName) { root.classList.remove('is-scroll-hidden'); lastY = y; }
			else if (y > lastY + 8) { root.classList.add('is-scroll-hidden'); lastY = y; }
			else if (y < lastY - 8) { root.classList.remove('is-scroll-hidden'); lastY = y; }
		}
		if (openName) { setTop(); }
	}
	window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });
	/* promjena sirine: desktop meni (i zakljucavanje skrola) se zatvara ispod 990 px, mobilni iznad 989 px */
	window.addEventListener('resize', function () {
		var w = window.innerWidth;
		if (w < 990 && openName) { close(); }
		if (w >= 990 && mmIsOpen()) { mmSet(false); }
		measure(); onScroll();
	});
	measure(); placeBar(lastY); onScroll();

	/* broj u kosarici: Liquid ispisuje cart.item_count; dalje dogadjaj jfn:cart:updated (agent KOSARICA) — detail moze biti cart objekt, {item_count} ili {cart}; bez broja u detailu cita se /cart.js */
	var counts = qa('[data-jfh-cart-count]');
	function setCount(n) {
		n = parseInt(n, 10); if (isNaN(n) || n < 0) { n = 0; }
		[].forEach.call(counts, function (el) { el.setAttribute('data-count', String(n)); el.textContent = n > 99 ? '99+' : String(n); });
	}
	function onCart(e) {
		var det = e && e.detail, n = null;
		if (det) { if (det.item_count != null) { n = det.item_count; } else if (det.cart && det.cart.item_count != null) { n = det.cart.item_count; } else if (det.count != null) { n = det.count; } }
		if (n != null) { setCount(n); return; }
		if (window.fetch) { fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { setCount(c && c.item_count); }).catch(function () {}); }
	}
	d.addEventListener('jfn:cart:updated', onCart);
	window.addEventListener('jfn:cart:updated', onCart);
	/* povratak iz bfcache: broj je mogao ostati star */
	window.addEventListener('pageshow', function (e) { if (e.persisted) { onCart(null); } });

	/* Reviews.io ocjena (isti izvor kao dosadasnja traka) */
	var ratingEls = qa('[data-jfh-rating]');
	if (ratingEls.length && window.fetch) {
		var run = function () {
			fetch('https://api.reviews.io/merchant/reviews?store=www.thefrankjuice.com').then(function (r) { return r.json(); }).then(function (j) {
				var v = parseFloat(j && j.stats && j.stats.average_rating);
				if (!v) { return; }
				[].forEach.call(ratingEls, function (el) { el.textContent = v.toFixed(1); });
			}).catch(function () {});
		};
		if ('requestIdleCallback' in window) { requestIdleCallback(run, { timeout: 4000 }); } else { setTimeout(run, 2500); }
	}
})();
